import { render, staticRenderFns } from "./ReleasePreview.vue?vue&type=template&id=698365c6&scoped=true&"
import script from "./ReleasePreview.vue?vue&type=script&lang=js&"
export * from "./ReleasePreview.vue?vue&type=script&lang=js&"
import style0 from "./ReleasePreview.vue?vue&type=style&index=0&id=698365c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698365c6",
  null
  
)

export default component.exports